<template>
    <header class="main-header">
        <div class="container" :class="{ scroll: open_progress }">

            <!-- auth buttons -->
            <AuthButtonsComponent />

            <!-- navigation -->
            <NavComponent />

            <!-- mobile menu icon -->
            <button class="mobile-icon" @click="toggle_mobile_menu">
                <img src="@/assets/profile/cactus.png" alt="">
            </button>   

            <!-- logo component -->
            <LogoComponent />

            <!-- progress bar -->
            <ProgressBarComponent :show="open_progress" />
        </div>
    </header>
    <MobileMenuComponent :open="open_mobile_menu" :toggle="toggle_mobile_menu" />
</template>
<script>
import LogoComponent from '../Logo/LogoComponent.vue';
import AuthButtonsComponent from './AuthButtonsComponent.vue';
import MobileMenuComponent from './MobileMenuComponent.vue';
import NavComponent from './NavComponent.vue';
import ProgressBarComponent from './ProgressBarComponent.vue';

export default {
    name: 'HeaderComponent',
    components: {
        ProgressBarComponent,
        LogoComponent,
        AuthButtonsComponent,
        NavComponent ,
        MobileMenuComponent
    },
    data() {
        return {
            open_progress: false ,
            open_mobile_menu: false
        }
    },
    mounted() {
        window.addEventListener('scroll', () => {
            if(this.open_mobile_menu){
                this.open_mobile_menu = false
            }
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            if (scrollTop > 0) {
                this.open_progress === false ? this.open_progress = true : false;
            } else {
                this.open_progress === true ? this.open_progress = false : false;
            }
        })
    } ,
    methods: {
        toggle_mobile_menu(){
            this.open_mobile_menu ? this.open_mobile_menu = false : this.open_mobile_menu = true 
        }
    }
}
</script>
<style scoped>
.main-header {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #f8f8f7;
    z-index: 500;
}

.main-header .container.scroll {
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.main-header .container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    transition: all 0.5s;
}

.mobile-icon {
    all: unset;
    display: none;
    padding: 0.5rem;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    /* border: 1px solid #bdc3c7; */
}

.mobile-icon img {
    width: 100%;
    height: 100%;
}

@media(max-width:767px) {
    .mobile-icon {
        display: block;
    }
}
</style>